import type { CharacterDef } from '@archon3d/core';

/** What flies when a character shoots: how the shot looks in the arena and how it sounds. */
export type ProjectileFlavour = 'arrow' | 'fire' | 'bolt' | 'rock' | 'spit';

/**
 * What a character shoots, read from its stats rather than its id so new characters get a
 * fitting shot without engine changes: casters fire bolts of magic, fliers breathe fire,
 * big brutes throw rocks, ground creatures that slither spit, the swift shoot beams and the
 * rest loose arrows.
 */
export function projectileFlavour(character: CharacterDef): ProjectileFlavour {
  if (character.spellcaster) return 'bolt';
  if (character.movement.type === 'fly') return 'fire';
  if (character.tier >= 4) return 'rock';
  if (character.model?.motion === 'float') return 'spit';
  if (character.movement.range >= 4) return 'bolt';
  return 'arrow';
}

/** What a fighter shoots in a duel: a mimic shoots whatever its opponent shoots. */
export function shotFlavour(
  character: CharacterDef | undefined,
  opponent: CharacterDef | undefined,
): ProjectileFlavour {
  if (!character) return 'bolt';
  if (character.attack.type === 'mimic')
    return opponent && opponent.attack.type !== 'mimic' ? projectileFlavour(opponent) : 'bolt';
  return projectileFlavour(character);
}
